import { Mail, Phone, Tag as TagIcon } from 'lucide-react'
import type { FC } from 'react'

import { Tag } from '@/components/tag/tag'

import type { ResApplicantDetail } from '@/lib/queries/business/v1/types'

import { ApplicantConfigs } from './applicant-configs'
import { ApplicantInfoEntry } from './applicant-info-entry'
import { ApplicantName } from './applicant-name'

export const ApplicantInfo: FC<{
  applicant: ResApplicantDetail
  onInvalidate: () => Promise<void>
}> = ({ applicant, onInvalidate }) => {
  return (
    <>
      <div className="mb-4 flex items-end justify-between">
        <ApplicantName name={applicant.applicant_name} />
        <ApplicantConfigs applicant={applicant} onInvalidate={onInvalidate} />
      </div>
      <div className="flex gap-[70px] border-b pb-4">
        <ApplicantInfoEntry
          label="Email"
          icon={<Mail size={16} />}
          value={<a href={`mailto:${applicant.email}`}>{applicant.email}</a>}
        />
        <ApplicantInfoEntry label="Phone Number" icon={<Phone size={16} />} value={applicant.phone} />
        <ApplicantInfoEntry
          label="Tags"
          icon={<TagIcon size={16} />}
          value={
            applicant.tags ? (
              <div className="mt-0.5 flex flex-wrap gap-2">{applicant.tags?.map((x, i) => <Tag key={i}>{x}</Tag>)}</div>
            ) : (
              '-'
            )
          }
        />
      </div>
    </>
  )
}
